import Vue from "vue";

Vue.component("legal-basis-select", {
    props: [
        "value",
        "language",
        "notificationFormat"
    ],
    data() {
        return {
            loading: false,
            myValue: this.value,
            legalBases: []
        }
    },
    mounted() {
        const self = this;
        this.loading = true;
        this.$services.legalBasis.getDropdownItems({
            language: this.language,
            notificationFormatId: this.notificationFormat
        })
            .then((data) => {
                this.loading = false;

                this.legalBases = data;
            });
    },
    watch: {
        myValue: function (value) {
            if (value != this.value) {
                this.$emit('update:value', value);
            }
        },
        value: function (value) {
            if (value != this.myValue) {
                this.myValue = value;
            }
        }
    },
    template: `
      	<div>
	  		<template v-if="loading"><loading></loading></template>
			<template v-else>
				<b-select v-model="myValue">
					<option
						v-for="option in legalBases"
						:value="option.id"
						:key="option.id">
						{{ option.text }}
					</option>
				</b-select>
			</template>
      </div>
	`
});